import { api } from "@/lib/apiClient";
import {
  fetchSalesIndex,
  salesIndexErrorMessage,
  type SaleIndexRecord,
} from "@/lib/sales/salesIndexStore";
import type { SaleInvoiceRecord } from "@/lib/sales/saleInvoiceStore";

export type CarExchangeScope = "returnable" | "exchanged";

const PER_PAGE = 100;

export async function syncCarExchangesFromApi(scope: CarExchangeScope): Promise<SaleIndexRecord[]> {
  const collected: SaleIndexRecord[] = [];
  let page = 1;
  let lastPage = 1;
  do {
    const res = await fetchSalesIndex({ page, per_page: PER_PAGE, scope });
    collected.push(...(res.data ?? []));
    lastPage = res.meta?.last_page ?? 1;
    page += 1;
  } while (page <= lastPage && page <= 50);
  return collected;
}

export async function processCarExchange(
  saleId: string | number,
  payload: {
    exchange_date?: string | null;
    notes?: string | null;
    replacement_product_id: number;
    replacement_sale_amount: number;
    payment_method?: string | null;
    bank_id?: number | null;
    bank_name?: string | null;
    transaction_reference_no?: string | null;
    pay_order_no?: string | null;
    refunds?: Array<{
      amount: number;
      payment_method?: string | null;
      bank_id?: number | null;
      bank_name?: string | null;
      transaction_reference_no?: string | null;
      pay_order_no?: string | null;
      notes?: string | null;
    }>;
    collections?: Array<{
      amount: number;
      payment_method?: string | null;
      bank_id?: number | null;
      bank_name?: string | null;
      transaction_reference_no?: string | null;
      pay_order_no?: string | null;
      notes?: string | null;
      payment_date?: string | null;
      payment_mode?: string | null;
    }>;
  },
): Promise<{ message: string; record: SaleInvoiceRecord | null }> {
  const response = await api.post<{ message?: string; data?: SaleInvoiceRecord }>(
    `/api/v1/sales/${saleId}/exchange`,
    payload,
  );
  return {
    message: response.data?.message ?? "Car exchange completed.",
    record: response.data?.data ?? null,
  };
}

export { salesIndexErrorMessage };
export type { SaleIndexRecord };
